<div id="orders" class="page-layout carded fullwidth">
    <div class="top-bg primary"></div>
    <div class="center" fusePerfectScrollbar>

        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutGap="20px" fxLayoutAlign.gt-xs="space-between center">

            <div class="mat-display-1 my-0 my-sm-24 welcome-message">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'GENERAL_REPORT' |translate}}</span>
            </div>

            <div class="search-wrapper  ml-sm-32">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>search</mat-icon>
                    <input #filter [(ngModel)]="filterText" placeholder="{{'SEARCH' | translate}}">
                </div>
            </div>
            <div>
            </div>
        </div>

        
        <div class="center">
            <div class="widget-group p-12" fxLayout="row wrap" fxFlex="100" *fuseIfOnDom
                [@animateStagger]="{value:'50'}">

                <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                    fxFlex.gt-xs="50" fxFlex.gt-md="20">

                    <div class="fuse-widget-front h-100-p">
                        <div class="pt-48 px-12 pb-32" fxLayout="column" fxLayoutAlign="center center">
                            <div class="light-blue-fg font-size-52 line-height-52">
                                {{widgetTotalContainer}}
                            </div>
                            <div class="h3 secondary-text font-weight-500">{{'TOTAL_CONTAINER_COUNT' | translate}}
                            </div>
                        </div>
                    </div>

                </fuse-widget> 

                <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                    fxFlex.gt-xs="50" fxFlex.gt-md="20">

                    <div class="fuse-widget-front h-100-p">
                        
                        <div class="pt-48 px-12 pb-32" fxLayout="column" fxLayoutAlign="center center">
                            <div class="red-fg font-size-52 line-height-52">
                                {{widgetTotalOptimize}}
                            </div>
                            <div class="h3 secondary-text font-weight-500">{{'OPTIMIZE_ROUTE_CONTAINER_COUNT'|translate}}
                            </div>
                        </div>
                    </div>
                    
                </fuse-widget>


                <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                    fxFlex.gt-xs="50" fxFlex.gt-md="20">

                    <div class="fuse-widget-front h-100-p">

                        <div class="pt-48 px-12 pb-32" fxLayout="column" fxLayoutAlign="center center">
                            <div class="light-blue-fg font-size-32 line-height-52">
                                {{widgetBaseCost | number : '1.2-2'}}
                            </div>
                            <div class="h3 secondary-text font-weight-500">{{'BASE_COST'|translate}}
                            </div>
                        </div>
      
                    </div>

                </fuse-widget>

                <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                    fxFlex.gt-xs="50" fxFlex.gt-md="20">

                    <div class="fuse-widget-front h-100-p">

                        <div class="pt-48 px-12 pb-32" fxLayout="column" fxLayoutAlign="center center">
                            <div class="orange-fg font-size-32 line-height-52">
                              {{widgetOptimizeCost | number : '1.2-2'}}
                            </div>
                            <div class="h3 secondary-text font-weight-500">{{'OPTIMIZE_COST'|translate}}
                            </div>
                        </div>
               
                    </div>

                </fuse-widget>

                <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                    fxFlex.gt-xs="50" fxFlex.gt-md="20">

                    <div class="fuse-widget-front h-100-p">

                        <div class="pt-48 px-12 pb-32" fxLayout="column" fxLayoutAlign="center center" style="text-align: center;">
                            <div class="purple-fg font-size-32 line-height-52">
                               {{widgetTotalSaving | number : '1.2-2'}}
                            </div>
            
                            <div class="h3 secondary-text font-weight-500">{{'SAVING_TOTAL'|translate}}
                            </div>
                        </div>
                 
                    </div>

                </fuse-widget>

            </div>

        </div>

        <div>
            <div class="content-card p-20">
                <mat-card style="padding: 0 !important;">
                    <div class="p-20 table-select-style" fxLayout="row" fxLayoutAlign="space-between center">
                        <mat-card-title class="custom-card-title" fxFlex="70">{{'GENERAL_REPORT' | translate}} 
                        <span *ngIf="selectByFilter=='special'">({{_generalReport.length>0?((_generalReport[0].timeFilterType | timeFilterType) | translate):''}})</span>
                        <span *ngIf="selectByFilter!='special'">({{((selectByFilter | timeFilterType) | translate)}})</span>
                        </mat-card-title>
                        <div fxLayout="column">
                            <span style="font-size: medium; font-weight: 600;">Tarih Filtresi</span>
                            <div>
                                <span style="font-size: small; font-weight: 300;">{{StartTime | date:"dd.MM.yyyy"}}</span> - 
                                <span style="font-size: small; font-weight: 300;">{{EndTime | date:"dd.MM.yyyy"}}</span>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutGap="5px" fxLayoutGap.gt-sm="10px">
                            <button mat-mini-fab [matMenuTriggerFor]="menuUnloadingFilter">
                                <mat-icon>tune</mat-icon>
                            </button>
                            <mat-menu #menuUnloadingFilter="matMenu">
                                <div *ngIf="rootCompanyId==1" mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                    <mat-form-field class="w-100-p" appearance="outline">
                                        <mat-label>{{'COMPANY'|translate}}</mat-label>
                                        <mat-select [(ngModel)]="companyId">
                                            <mat-option *ngFor="let company of companies" (click)="refresh()"
                                                [value]="company.id">{{company.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div mat-menu-item style="height: 75px;"  (click)="$event.stopPropagation();">
                                    <mat-form-field class="w-100-p" appearance="outline">
                                        <mat-label>{{'CHOOSE_DATE'|translate}}</mat-label>
                                        <mat-select [(ngModel)]="selectByFilter">
                                            <mat-option (click)="onTimeChangeClick('day')" value="day">
                                                {{'TODAY'|translate}}
                                            </mat-option>
                                            <mat-option (click)="onTimeChangeClick('month')" value="month">
                                                {{'THIS_MONTH'|translate}}
                                            </mat-option>
                                            <mat-option (click)="onTimeChangeClick('year')" value="year">
                                                {{'THIS_YEAR'|translate}}
                                            </mat-option>
                                            <mat-option [matMenuTriggerFor]="menu" value="special">
                                                {{'OTHER'|translate}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-menu #menu="matMenu">
                                        <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                            <mat-form-field appearance="outline" floatLabel="always">
                                                <mat-label>{{'START_DATE'|translate}}</mat-label>
                                                <input matInput [ngxMatDatetimePicker]="startpicker" name="startpicker"
                                                    placeholder="{{'START_DATE'|translate}}" [(ngModel)]="StartTime" required>
                                                <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
                                                <ngx-mat-datetime-picker #startpicker>
                                                    <ng-template>
                                                        <span>OK</span>
                                                    </ng-template>
                                                </ngx-mat-datetime-picker>
                                            </mat-form-field>
                                        </div>
                                        <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                            <mat-form-field appearance="outline" floatLabel="always">
                                                <mat-label>{{'END_DATE'|translate}}</mat-label>
                                                <input matInput [ngxMatDatetimePicker]="endRatePicker" name="endRatePicker"
                                                    placeholder="{{'END_DATE'|translate}}" [(ngModel)]="EndTime" required>
                                                <mat-datepicker-toggle matSuffix [for]="endRatePicker"></mat-datepicker-toggle>
                                                <ngx-mat-datetime-picker #endRatePicker>
                                                    <ng-template>
                                                        <span>OK</span>
                                                    </ng-template>
                                                </ngx-mat-datetime-picker>
                                            </mat-form-field>
                                        </div>
                                        <div mat-menu-item
                                            (click)="StartTime && EndTime ?onTimeChangeClick('special',StartTime,EndTime):$event.stopPropagation()">
                                            OK
                                        </div>
                                    </mat-menu>
                                </div>
                            </mat-menu>
                            <!-- <button mat-mini-fab (click)="onReportClick()">
                                <mat-icon>cloud_download</mat-icon>
                            </button> -->
                        </div>

                    </div>
                    <div class="p-20 pt-0" style="overflow: auto;" fusePerfectScrollbar>
                        <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px; min-width: 700px;" #table matSortActive="beforeDate"
                        matSortDirection="desc"
                            [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}">

                            <ng-container matColumnDef="created_at">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                    <span class="mr-8">{{'DATE' | translate}}</span> 
                                    <mat-icon matTooltip="Tarih">error_outline</mat-icon>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    <a href="javascript:void(null)" (click)="onTableRowChange(generalZone)">
                                        {{generalZone.created_at!=null?
                                            ((generalZone.timeFilterType == 'day'?
                                                (generalZone.created_at | date:'dd.MM.yyyy')
                                                    :(generalZone.created_at | date:'MM/yyyy')))
                                                        :"---"}}
                                    </a>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="totalPolygonCount">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                   <span class="mr-8">{{'TOTAL_REGION_COUNT' | translate}}</span> 
                                   <mat-icon matTooltip="Bulunan toplam bölge sayısı">error_outline</mat-icon>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.totalPolygonCount!=null?generalZone.totalPolygonCount:"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="totalContainerCount">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                   <span class="mr-8">{{'TOTAL_CONTAINER_COUNT' | translate}}</span> 
                                    <mat-icon matTooltip="Bulunan toplam konteyner sayısı">error_outline</mat-icon>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.totalContainerCount!=null?generalZone.totalContainerCount:"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="totalOptimizeCount">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                    <span class="mr-8">{{'OPTIMIZE_ROUTE_CONTAINER_COUNT' | translate}}</span> 
                                    <mat-icon matTooltip="Doluluk oranları bölgenin toplama eşiğinden fazla olan konteyner adedi">error_outline</mat-icon>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.totalOptimizeCount!=null?generalZone.totalOptimizeCount:"---"}}
                                </mat-cell>
                            </ng-container>


                            <ng-container matColumnDef="totalBaseRouteKm">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                    <span class="mr-8">{{'BASE_ROUTE_KM'|translate}}</span>
                                    <mat-icon matTooltip="Tüm konteynerleri dolaşacağı rotanın kilometresi">error_outline</mat-icon>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.totalBaseRouteKm!=null?((generalZone.totalBaseRouteKm / 1000) | number : '1.2-2'):'---'}} 
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="totalOptimizeRouteKm">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                   <span class="mr-8">{{'OPTIMIZE_ROUTE_KM'|translate}}</span>
                                    <mat-icon matTooltip="Sistem tarafından doluluk oranı bölgenin toplama eşiğinden yüksek olan konteynerleri dolaşacağı rota kilometresi.">error_outline</mat-icon>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.totalOptimizeRouteKm!=null?((generalZone.totalOptimizeRouteKm / 1000)| number : '1.2-2'):'---'}} 
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="totalMileageSavings">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                   <span class="mr-8">{{'MILEAGE_SAVINGS'|translate}}</span>
                                   <mat-icon matTooltip="Tüm konteynerleri dolaşıldığı rotanın kilometresinden, bölgenin toplama eşiğinden yüksek olan konteynerleri dolaştığı rotanın kilometresinden farkı">error_outline</mat-icon> 
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.totalMileageSavings!=null?(generalZone.totalMileageSavings| number : '1.2-2'):"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="totalTimeSavings">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                    <span class="mr-8">{{'TIME_SAVINGS'|translate}}</span> 
                                    <mat-icon matTooltip="Tüm konteynerleri dolaşıldığı rotanın süresinden, bölgenin toplama eşiğinden yüksek olan konteynerleri dolaştığı rotanın süresinden farkı">error_outline</mat-icon>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.totalTimeSavings!=null?(generalZone.totalTimeSavings| number : '1.2-2'):"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="productivity">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                    <span class="mr-8">{{'PRODUCTIVITY'|translate}}</span>
                                    <mat-icon matTooltip="Bütün konteynerlerin dolaşılacak konteynerlere yüzdesel oranı">error_outline</mat-icon>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.productivity!=null?(generalZone.productivity| number : '1.2-2'):"---"}} %
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="totalBaseCost">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                    <span class="mr-8">{{'BASE_COST'|translate}}</span>
                                    <mat-icon matTooltip="Tüm konteynereleri dolaşacak rotanın maliyet">error_outline</mat-icon>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.totalBaseCost!=null?(generalZone.totalBaseCost| number : '1.2-2'):"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="totalOptimizeCost">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                    <span class="mr-8">{{'OPTIMIZE_COST'|translate}}</span>
                                    <mat-icon matTooltip="Bölgenin toplama eşiğinden yüksek olan konteynereleri dolaşacağı rotanın maliyeti">error_outline</mat-icon>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.totalOptimizeCost!=null?(generalZone.totalOptimizeCost| number : '1.2-2'):"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="totalMileageSavingsCost">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                    <span class="mr-8">{{'MILEAGE_SAVINGS_COST'|translate}}</span>
                                    <mat-icon matTooltip="Kilometre tasarufundan oluşan maliyet kazancı">error_outline</mat-icon>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.totalMileageSavingsCost!=null?(generalZone.totalMileageSavingsCost| number : '1.2-2'):"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="totalTimeSavingsCost">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                    <span class="mr-8">{{'TIME_SAVINGS_COST'|translate}}</span>
                                    <mat-icon matTooltip="Zaman tasarufundan oluşan maliyet kazancı">error_outline</mat-icon>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.totalTimeSavingsCost!=null?(generalZone.totalTimeSavingsCost| number : '1.2-2'):"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="totalSavingTotal">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                    <span class="mr-8">{{'SAVING_TOTAL'|translate}}</span>
                                    <mat-icon matTooltip="Toplam Kazanç">error_outline</mat-icon>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.totalSavingTotal!=null?(generalZone.totalSavingTotal| number : '1.2-2'):"---"}}
                                </mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                            <mat-row *matRowDef="let generalZone; columns: displayedColumns;" class="order" matRipple>
                            </mat-row>
                        </mat-table>

                        <mat-paginator style="min-width: 700px;" #paginator [length]="paginator.length" [pageSize]="10"
                            [pageSizeOptions]="[10, 50, 100]">
                        </mat-paginator>
                    </div>
                    <mat-progress-bar [fxShow]="tableLoading" style="border-radius: 10px;" mode="indeterminate">
                    </mat-progress-bar>
                </mat-card>

            </div>
            
            <div class="content-card p-20">
                <div class="w-100-p" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px">
                    <mat-card fxFlex>
                        <mat-card-title class="custom-card-title" >{{'Tasarruf' | translate}}</mat-card-title>
                        <div id="chartProductivity">
                            <apx-chart
                              [series]="chartOptionsProductivity.series"
                              [chart]="chartOptionsProductivity.chart"
                              [xaxis]="chartOptionsProductivity.xaxis"
                              [stroke]="chartOptionsProductivity.stroke"
                              [theme]="chartOptionsProductivity.theme"
                              [dataLabels]="chartOptionsProductivity.dataLabels"
                              [yaxis]="chartOptionsProductivity.yaxis"
                              [labels]="chartOptionsProductivity.labels"
                              [legend]="chartOptionsProductivity.legend"
                              [title]="chartOptionsProductivity.title"
                            ></apx-chart>
                          </div>
                    </mat-card>
                    
                    <mat-card fxFlex>
                        <mat-card-title class="custom-card-title" >{{'Maliyet Grafiği' | translate}}</mat-card-title>
                        <div id="chartCost">
                            <apx-chart
                              [series]="chartOptionsCost.series"
                              [chart]="chartOptionsCost.chart"
                              [xaxis]="chartOptionsCost.xaxis"
                              [stroke]="chartOptionsCost.stroke"
                              [tooltip]="chartOptionsCost.tooltip"
                              [fill]="chartOptionsCost.fill"
                              [plotOptions]="chartOptionsCost.plotOptions"
                              [theme]="chartOptionsCost.theme"
                              [dataLabels]="chartOptionsCost.dataLabels"
                              [yaxis]="chartOptionsCost.yaxis"
                              [labels]="chartOptionsCost.labels"
                              [legend]="chartOptionsCost.legend"
                              [title]="chartOptionsCost.title"
                            ></apx-chart>
                          </div>
                    </mat-card>
                </div>
            </div>
        </div>

    </div>
</div>